import { TempSaveData } from '@/fetches/user/documents/tempsave/get-temp-save-data';
import { createSliceSteamup } from '../common';

interface ITempDataState {
  data: TempSaveData[];
}

const initialState = {
  data: [],
} as ITempDataState;

const tempDataSlice = createSliceSteamup(
  'tempData',
  initialState,
  {
    init() {
      return initialState;
    },
  },
);

export default tempDataSlice;
